module.exports = __webpack_public_path__ + "img/restaurant_card_image07.ba605b9d.png";